export default `
District,Party,Surname,AB68,AB215,AB787,AB1398,SB8,SB9,SB10,SB290,SB477,SB478,
26,(D),Allen,Aye,NVR,Aye,Aye,Aye,NVR,NVR,Aye,Aye,Aye,
32,(D),Archuleta,Aye,NVR,Aye,NVR,Aye,Aye,Aye,Aye,Aye,Aye,
39,(D),Atkins,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
36,(R),Bates,Aye,No,Aye,No,No,No,No,No,Aye,No,
13,(D),Becker,Aye,Aye,Aye,Aye,Aye,Aye,NVR,Aye,Aye,Aye,
8,(R),Borgeas,Aye,No,Aye,No,NVR,No,Aye,No,Aye,No,
35,(D),Bradford,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
12,(D),Caballero,Aye,NVR,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
15,(D),Cortese,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
1,(R),Dahle,Aye,No,Aye,No,NVR,Aye,Aye,NVR,NVR,Aye,
3,(D),Dodd,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
24,(D),Durazo,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
5,(D),Eggman,NVR,NVR,NVR,NVR,Aye,Aye,Aye,Aye,Aye,NVR,
7,(D),Glazer,Aye,NVR,Aye,Aye,No,No,Aye,Aye,Aye,Aye,
33,(D),Gonzalez,Aye,NVR,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
16,(R),Grove,Aye,No,Aye,No,NVR,Aye,Aye,NVR,Aye,No,
18,(D),Hertzberg,Aye,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,Aye,
40,(D),Hueso,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
14,(D),Hurtado,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
38,(R),Jones,Aye,No,Aye,No,NVR,No,Aye,No,Aye,Aye,
30,(D),Kamlager,Aye,Aye,Aye,Aye,Aye,NVR,No,Aye,Aye,Aye,
17,(D),Laird,Aye,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,Aye,
20,(D),Leyva,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
19,(D),Limón,Aye,NVR,Aye,Aye,Aye,NVR,NVR,Aye,NVR,NVR,
2,(D),McGuire,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
28,(R),Melendez,Aye,No,Aye,No,NVR,No,NVR,NVR,Aye,No,
37,(D),Min,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
29,(D),Newman,Aye,NVR,Aye,NVR,Aye,NVR,NVR,Aye,Aye,Aye,
4,(R),Nielsen,Aye,No,Aye,No,NVR,Aye,Aye,No,Aye,Aye,
23,(R),Ochoa Bogh,Aye,No,Aye,No,Aye,No,Aye,Aye,Aye,No,
6,(D),Pan,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
25,(D),Portantino,Aye,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,NVR,
31,(D),Roth,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
22,(D),Rubio,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
9,(D),Skinner,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
27,(D),Stern,NVR,NVR,NVR,NVR,NVR,NVR,NVR,NVR,NVR,NVR,NO VOTES CAST!!!
34,(D),Umberg,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
10,(D),Wieckowski,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
11,(D),Wiener,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,
21,(D),Wilk,Aye,No,Aye,No,No,No,No,Aye,Aye,No,
`
